import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { TextField } from '@material-ui/core'

/*
 * This component as it is now only works in Redux Form forms
 */
class Input extends Component {
  constructor (props) {
    super(props)
    this.state = {
      value: props.input.value
    }
    this.inputRef = React.createRef()
  }

  componentDidMount () {
    if (this.props.value) {
      this.setState({ value: this.props.value })
    }
  }

  render () {
    const {
      id,
      input: { value: inputValue, onChange, ...restInput },
      placeholder,
      type,
      meta: { touched, error },
      block,
      disabled
    } = this.props

    const { value } = this.state

    return (
      <TextField
        id={id}
        fullWidth={block}
        value={value || this.props.input?.value}
        inputRef={this.inputRef}
        onChange={this.handleChange}
        helperText={touched && error}
        error={touched && !!error}
        label={placeholder}
        type={type}
        margin='normal'
        inputProps={{
          'data-testid': `test-${id}`,
          disabled: disabled,
          style: { color: disabled ? 'gray' : 'inherit' }
        }}
        FormHelperTextProps={{
          'data-testid': `test-${id}-helper-text`
        }}
        {...restInput}
      />
    )
  }

  /*
   * This function handles a problem detailed here: https://github.com/facebook/react/issues/12762
   */
  handleChange = (e) => {
    const {
      normalizers,
      input: { onChange }
    } = this.props
    const newValue = normalizers
      ? normalizers.reduceRight((val, fn) => fn(val), e.target.value)
      : e.target.value
    this.setState(
      {
        value: newValue
      },
      () => {
        onChange(newValue)
      }
    )
  }
}

Input.propTypes = {
  input: PropTypes.object,
  placeholder: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  meta: PropTypes.object.isRequired,
  block: PropTypes.bool,
  id: PropTypes.string,
  normalizers: PropTypes.array,
  value: PropTypes.string,
  disabled: PropTypes.bool
}

Input.defaultValues = {
  block: false
}

export default Input
